import { Category } from "src/app/models/Category";
import { ProductFilter } from "./ProductFilter";
import { eProductFilterGroupType } from "./eProductFilterGroupType";
import { eProductFilterType } from "./eProductFilterItemType";
import { CompanyValues } from "src/app/helpers/CompanyValues";
import { Params } from "@angular/router";

export function ProductFilterArrayBuilder(categories:Category[], queryParameters:Params) : ProductFilter[] {
	let activeFilters : ProductFilter[] = [];

	let category = categories.find(c=> c.id == queryParameters["c"]);
	if (category) {
		let categoryFilter = new ProductFilter(category.id, eProductFilterGroupType.CATEGORIES, eProductFilterType.EQUAL, category.title);
		activeFilters.push(categoryFilter);
	}

	let freeShipping = queryParameters["g"];
	if (freeShipping) {
		activeFilters.push(new ProductFilter(1, eProductFilterGroupType.SHIPPING, eProductFilterType.EQUAL, "Envío gratis"));
	}

	let priceRange = queryParameters["p"];
	if (priceRange) {
		let rangeSplit = priceRange.split(",");
		let n1 = Number(rangeSplit[0]);
		let n2 = Number(rangeSplit[1]);
		if (n1 && n2 && n1 > 0 && n1 <= n2)
			activeFilters.push(new ProductFilter(1, eProductFilterGroupType.PRICES, eProductFilterType.RANGE_INPUT, undefined, n1, n2));
	}

	let discountRange = queryParameters["d"];
	if (discountRange) {
		let rangeSplit = discountRange.split(",");
		let n1 = Number(rangeSplit[0]);
		let n2 = Number(rangeSplit[1]);
		if (n1 && n2 && n1 > 0 && n2 <= 100 && n1 <= n2)
			activeFilters.push(new ProductFilter(1, eProductFilterGroupType.DISCOUNTS, eProductFilterType.RANGE_INPUT, undefined, n1, n2));
	}

	let value = CompanyValues.find(cv=> cv.id == queryParameters["v"]);
	if (value) {
		activeFilters.push(new ProductFilter(value.id, eProductFilterGroupType.VALUABLES, eProductFilterType.EQUAL, value.title));
	}

	return activeFilters;
}